import { OverlayTrigger, Tooltip, Button } from 'react-bootstrap';
import { toast } from 'react-toastify';

function closeModalOverlay() {
  let body = document.body;
  body.classList.remove('quickview-modal-open');
}

export function QuickView({ quickviewData, index, children, activeD365QuickViews, setActiveD365QuickViews }) {

  const minizeQuickView = () => {
    const maxQuickViews = 4;

    if (activeD365QuickViews.length < maxQuickViews) {
      closeModalOverlay();
      setActiveD365QuickViews(activeD365QuickViews.map(el => el === quickviewData ? { ...el, isMinimized: !el.isMinimized } : el));
    } else {
      toast('Max Docked Views is 3, please remove one before adding a new one', {
        position: 'bottom-right',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true
      });
    }
  };

  const closeQuickView = () => {
    closeModalOverlay();
    setActiveD365QuickViews(activeD365QuickViews.filter(el => el !== quickviewData));
  };

  const resizeQuickView = () => {
    setActiveD365QuickViews(activeD365QuickViews.map(el => el === quickviewData ? { ...el, isMaximized: !el.isMaximized } : el));
  };

  return (
    <>
      <div id='dimel' onClick={() => closeQuickView()} className={quickviewData.isMinimized ? 'd-none' : ''}></div>
      <div className={quickviewData.isMinimized ? 'quickview-modal minimized d-none' : quickviewData.isMaximized ? 'quickview-modal maximized' : 'quickview-modal'} style={quickviewData.isMinimized ? { transformOrigin: `${(150 - (30 * index))}% 110%` } : {}} >
        <div id='quickview-blocker' className={quickviewData.isMinimized ? 'd-block' : 'd-none'} style={quickviewData.isPrimary ? { backgroundColor: '#689df6' } : {}}>
          <div className='minimized-options'>
            <div className='title-container'>
              <OverlayTrigger
                placement='top'
                overlay={
                  <Tooltip className='docked-tooltip'>
                    {quickviewData.title}
                  </Tooltip>
                }
              >
                <p className='quickview-title' onClick={() => minizeQuickView()}>{quickviewData.isPrimary ? <i className='far fa-lightbulb mr-1'></i> : <i className='fas fa-eye mr-1'></i>} {quickviewData.title}</p>
              </OverlayTrigger>
            </div>

            <div className='btn-container'>
              <Button variant='link' onClick={() => minizeQuickView()}><i className='fas fa-long-arrow-alt-down' style={{ transform: 'rotate(-45deg)' }}></i></Button>
              <Button variant='link' onClick={() => closeQuickView()}>X</Button>
            </div>

          </div>
        </div>
        <div role='document' className='modal-dialog active'>
          <div className='modal-content'>
            <div className='quickview-header text-right'>
              <OverlayTrigger
                placement='bottom'
                overlay={
                  <Tooltip>
                    Dock
                  </Tooltip>
                }
              >
                <Button variant='link' onClick={() => { minizeQuickView(); }}><i className='fas fa-long-arrow-alt-down' style={{ transform: 'rotate(-45deg)' }}></i></Button>
              </OverlayTrigger>
              <OverlayTrigger
                placement='bottom'
                overlay={
                  <Tooltip>
                    {!quickviewData.isMaximized ? 'Expand' : 'Shrink'
                    }
                  </Tooltip>
                }
              >
                <Button variant='link' onClick={() => resizeQuickView()}>
                  {!quickviewData.isMaximized ?
                    <i className='fas fa-expand-arrows-alt'></i>
                    :
                    <i className='fas fa-compress-arrows-alt'></i>
                  }
                </Button>
              </OverlayTrigger>
              <OverlayTrigger
                placement='bottom'
                overlay={
                  <Tooltip>
                    Close
                  </Tooltip>
                }
              >
                <Button variant='link' onClick={() => closeQuickView()}>X</Button>
              </OverlayTrigger>
            </div>
            {children}
          </div>
        </div>
      </div>


      {quickviewData.isMinimized && (
        <div className={quickviewData.isPrimary ? 'isDocked primary' : 'isDocked'} style={{ right: `${index * 315}px` }}>
          <div className='title-container'>
            <OverlayTrigger
              placement='top'
              overlay={
                <Tooltip className='docked-tooltip'>
                  {quickviewData.title}
                </Tooltip>
              }
            >
              <p onClick={() => minizeQuickView()}>{quickviewData.isPrimary ? <i className='far fa-lightbulb mr-1'></i> : <i className='fas fa-eye mr-1'></i>} {quickviewData.title}</p>
            </OverlayTrigger>
          </div>

          <div className='btn-container'>
            <Button variant='link' onClick={() => minizeQuickView()}><i className='fas fa-long-arrow-alt-down' style={{ transform: 'rotate(-45deg)' }}></i></Button>
            <Button variant='link' onClick={() => closeQuickView()}>X</Button>
          </div>

        </div>
      )}
    </>
  );
}